import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { StyledTreeItem } from './treeStyle.js';
import Tooltip from '@material-ui/core/Tooltip';
import { _ } from '../../functions/translator.js';
import { Checkbox } from '@material-ui/core';
import { popUpMessageChange } from '../../actions/index';
import ItemInfo from './itemInfo.js';
import { showMessage } from '../../functions/popUpMessage.js';

class RecursiveTreeItem extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            progressDiff: 50
        }
    }

    handleCheck = (event) => {
        let item = JSON.parse(event.target.value)
        let message = '¿' + _('Agregar el 100% de avance')
        message += ' ' + _('a') + ' ' + item.name + '?'
        if (item.progress === '100.0%') {
            item.previousProgress = this.getPreviousItemProgress(item.id)
            message = '¿' + _('Quitar último porcentaje de avance')
            message += ' ' + _('a') + ' ' + item.name + '?'
        }
        const messageConfig = {
            closeButton: true,
            confirmAddProgress: true,
            item: item
        }
        showMessage(this.props, message, messageConfig)
    }

    getItemInfo(itemData) {
        let itemId = itemData.id
        let itemName = itemData.attributes.name
        let isTerminal = itemData.attributes.terminal
        let realProgress = this.getItemProgress(itemId)
        let [qualityProgress, volume] = this.getQualityProgress(itemId)
        let progressDiff = qualityProgress === '-' ? 0 : Math.abs(realProgress - qualityProgress)
        qualityProgress = qualityProgress === '-' ? qualityProgress : qualityProgress.toFixed(1) + '%'
        let itemInfo = <ItemInfo realProgress={realProgress} qualityProgress={qualityProgress}/>
        realProgress = realProgress.toFixed(1) + '%'
        let progressCheckbox = null
        let warningTooltip = null
        if (isTerminal && this.props.userRole.add_progress_update) {
            let value = JSON.stringify({ 
                id: itemId,
                name: itemName,
                progress: realProgress
            })
            progressCheckbox = <Checkbox 
                                checked={realProgress === '100.0%'} 
                                color="primary" 
                                value={value}
                                onChange={this.handleCheck}/>
        }
        if (volume > 0 && progressDiff > this.state.progressDiff) {
            warningTooltip = <Tooltip arrow 
                                title={
                                    <span style={{color: 'black'}}>{_("Mensaje de Advertencia")}
                                        <br></br>
                                        {_('Diferencia')+': ' + progressDiff.toFixed() + '%'}
                                    </span>
                                } placement="right">
                                <span role="img" aria-label="Warning">⚠️</span>
                            </Tooltip>
        } 
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Tooltip arrow title={itemInfo} placement="right">
                        <span className="item-name">
                            {progressCheckbox}
                            {itemName}
                        </span>
                    </Tooltip>
                    {warningTooltip}
                </div>
            </div>
        )
    }

    getItemProgress(itemId) {
        let itemProgress = JSON.parse(this.props.itemsProgress.items_progress[itemId.toString()].progress)
        let lastProgress = parseFloat(itemProgress[this.props.projectData.attributes.nr_of_weeks])
        return lastProgress 
    }

    getPreviousItemProgress(itemId) {
        let itemProgress = JSON.parse(this.props.itemsProgress.items_progress[itemId.toString()].progress)
        let prevProgress = 0
        if (this.props.projectData.attributes.nr_of_weeks > 0) {
            prevProgress = parseFloat(itemProgress[this.props.projectData.attributes.nr_of_weeks - 1])
        }
        return prevProgress
    }

    getQualityProgress(itemId) {
        let itemDataWithMetrics = this.props.qualityProgress.items_data_with_metrics[itemId]
        let volume = 0
        if (itemDataWithMetrics.length === 0) return ['-', volume]
        let closedPercentage = itemDataWithMetrics.attributes.closed_percentage
        let qualityProgress = Math.round(closedPercentage*100)
        volume = itemDataWithMetrics.attributes.volume
        if (volume === 0) {
            qualityProgress = '-'
        }
        return [qualityProgress, volume]
    }

	renderTree = (nodes) => (
		<StyledTreeItem 
            key={nodes.id} 
            nodeId={nodes.id} 
            label={ nodes.id !== 'root' ? this.getItemInfo(nodes) : nodes.attributes.name}>
			{nodes.hasOwnProperty('items') ? Object.values(nodes.items).map((node) => this.renderTree(node)) : null}
		</StyledTreeItem>
	);

	render() {
		return (
			<div className="aerial-list-tree-item-section">
				{this.renderTree(this.props.itemsData)}
			</div>
		);

	}

}

function mapStateToProps(state) {
	return {
		itemsData       : state.itemsData,
        projectData     : state.projectData,
        itemsProgress   : state.itemsProgress,
        qualityProgress : state.qualityProgress,
        userRole        : state.userRole
	}
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        popUpMessageChange : popUpMessageChange
    }, dispatch)
}


export default connect(mapStateToProps, matchDispatchToProps)(RecursiveTreeItem);